import { render, staticRenderFns } from "./PersonProfile.vue?vue&type=template&id=7d23cb66&scoped=true"
import script from "./PersonProfile.vue?vue&type=script&lang=js"
export * from "./PersonProfile.vue?vue&type=script&lang=js"
import style0 from "./PersonProfile.vue?vue&type=style&index=0&id=7d23cb66&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d23cb66",
  null
  
)

export default component.exports